import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { toggleSidebar } from "../../store/actions/layout";
import { GetAgent } from "../../store/actions/kalapost";
import { errorMessage } from "../../utils/message";

const Register = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { isSidebarOpened } = useSelector((state) => state.layout);

  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState({
    address: "",
    branchName: "",
    cityName: "",
    email: "",
    fax: "",
    managerName: "",
    managerPhoneNumber: "",
    phoneNumber: ""
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    const getAgentData = async () => {
      const res = await GetAgent();
      if (res.status) {
        setBranchList(res.data);
        setBranch(res.data[0]);
      }
    };
    getAgentData();
  }, []);

  const handelChangeBranch = (value) => {
    setBranch(prev => ({ ...prev, ...value }));

  };

  return (
    <main
      className="main--sendBox"
      onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
    >
      <div className="main__content-register">
        <div className="introduce">
          <div className="introduce__mainPart">
            <h2 className="introduce__title">ارسال بسته</h2>
            <p className="introduce__text">
              کالا پست به عنوان اولین پست خصوصی کشور که از طریق شبکه حمل و نقل
              اتوبوسی مرسولات خود را جابجا می کند سعی دارد تا با ارائه خدمات
              متنوع در ارسال کالاهای شما پاسخگوی تمام نیازهای مشتریان خود باشد .
              اگر بسته ای برای ارسال درون شهری و یا ارسال به هر نقطه از کشور در
              کمتر از 1روز دارید کالاپست همراه شماست تا مرسولات شما را به مقصد
              برساند . برای ارسال کالا از طریق کالاپست می توانید بصورت آنلاین از
              طریق وب سایت و یا نرم افزار موبایل کالاپست , تلفنی و یا مراجعه به
              یکی از نمایندگی های کالاپست در سراسر کشور ثبت سفارش کنید . بعد از
              ثبت سفارش , مرسولات شما وارد مراحل ارسال شده تا به مقصد برسد .
            </p>
          </div>
          <img
            className="introduce__imgPart"
            src="./img/image (2).svg"
            alt="sendBox"
          />
        </div>

        <div className="orders">
          <div className="kards__card kards__card-sendBox">
            <div className="orders__online-mainPart">
              <div className="orders__online-iconTitle">
                <img
                  src="./img/online-shop.svg"
                  alt="onlineonline"
                  className="orders__online-svg"
                />
                <h3 className="orders__online-title">سفارش آنلاین</h3>
              </div>
              <Link
                className="btn btn--Primary btn--Primary-sendBox"
                to="/order"
              >
                ثبت سفارش
              </Link>
            </div>
            <div className="orders__online-containerPart">
              <ul className="orders__online-lists">
                <li className="orders__online-item">
                  <p className="orders__online-number">1</p>
                  <p style={{ width: "80%" }}>ورود | ثبت نام به سایت یا اپ</p>
                </li>
                <li className="orders__online-item">
                  <p className="orders__online-number">2</p>
                  <p style={{ width: "80%" }}>ثبت درخواست ارسال بسته</p>
                </li>
                <li className="orders__online-item">
                  <p className="orders__online-number">3</p>
                  <p style={{ width: "80%" }}>
                    مراجعه نماینده کالاپست درب محل و دریافت بسته
                  </p>
                </li>
                <li className="orders__online-item">
                  <p className="orders__online-number">4</p>
                  <p style={{ width: "80%" }}>تحویل به گیرنده در اسرع وقت</p>
                </li>
              </ul>
            </div>
          </div>

          <div className="kards__card kards__card-sendBox">
            <div className="orders__agency-main">
              <img
                src="./img/earth.svg"
                alt="earth"
                className="orders__agency-svg"
              />
              <h3 className="orders__agency-title">سفارش از طریق نمایندگی</h3>
            </div>
            <div className="orders__agency-select">
              <label className="orders__agency-lable" htmlFor="pet-select">
                نمایندگی مورد نظر خود را انتخاب کنید:
              </label>
              <select
                id="pet-select"
                className="orders__agency-selector"
                value={branch.branchName}
                onChange={(e) => handelChangeBranch(branchList[e.target.selectedIndex - 1])}
              >
                <option hidden>نمایندگی مورد نظر</option>
                {branchList?.map((item, index) =>
                  <option key={index} value={item.branchName}>{item.branchName}</option>
                )}
              </select>
            </div>
            <div className="orders__agency-table">
              <div className="orders__agency-info">
                <p style={{ marginLeft: "2em" }}>شماره تلفن نمایندگی:</p>
                <p>{branch.phoneNumber || "_"}</p>
              </div>
              <div className="orders__agency-info">
                <p style={{ marginLeft: "2em" }}>آدرس نمایندگی:</p>
                <p>{branch.address || "_"}</p>
              </div>
              <div className="orders__agency-info">
                <p style={{ marginLeft: "2em" }}>ایمیل نمایندگی:</p>
                <p>{branch.email || "_"}</p>
              </div>
            </div>
          </div>

          <div className="kards__card kards__card-sendBox orders__calling">
            <div className="orders__calling-content">
              <div className="orders__calling-main">
                <img
                  src="./img/phone.svg"
                  alt="oldPhone"
                  className="orders__calling-svg"
                />
                <h5 className="orders__calling-title">
                  سفارش از طریق تماس با سامانه:
                </h5>
              </div>
              <p className="orders__calling-text">1820</p>
            </div>
            <img
              src="./img/calling 1.png"
              alt=""
              className="orders__calling-img"
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Register;
